module.exports = __webpack_public_path__ + "static/media/spotifybannermobil.958bc1de.png";